/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


/*
 * jQuery + jQuery UI + Popper + Bootstrap (JS)
 *
 * jQuery is automatically loaded by a Webpack plugin (no need to import/require it)
 * (the commented-out code will probably not be needed)
 */

//import 'jquery/src/jquery'
//import 'jquery'  // STILL WORKS

// these two came from <https://makandracards.com/makandra/69621-webpack-how-to-avoid-multiple-versions-of-jquery>
//window.$ = jQuery
//window.jQuery = jQuery

// this came from ...
//global.$ = jQuery  //require('jquery')
//global.jQuery = jQuery

import './jquery_ui_custom'
import './popper_custom'
import './bootstrap_custom'
import './fontawesome_custom'
